module.exports = __webpack_public_path__ + "static/media/M1-12-Yazorath-cod111.704448bc.png";